module.exports = __webpack_public_path__ + "static/img/b102.6f45c6a7.png";